// 排序 0正序 1 倒叙
export function compare (prop, orderBy) {
  return function (obj1, obj2) {
    const val1 = obj1[prop]
    const val2 = obj2[prop]
    if (val1 < val2) {
      return !orderBy ? -1 : 1
    } else if (val1 > val2) {
      return !orderBy ? 1 : -1
    } else {
      return 0
    }
  }
}

// 类型判断（大写）
export const typeOf = (obj) => {
  const objStr = Object.prototype.toString.call(obj)
  return objStr.replace('[object ', '').replace(']', '')
}

// 格式化数字
export function formatterNumber (value, pointNum = 1) {
  if (typeOf(value) === 'Number') {
    const valueStr = value.toFixed(pointNum)
    return parseFloat(valueStr)
  }
  return value
}

// 判断children
const nodeChildren = (setting, node, newChildren) => {
  if (!node) {
    return null
  }
  const key = setting.children
  if (typeof newChildren !== 'undefined') {
    // eslint-disable-next-line no-param-reassign
    node[key] = newChildren
  }
  return node[key]
}

// 平行树转children树
export const transPingTreeToChildren = (
  sNodes,
  setting = { id: 'id', pid: 'pid', children: 'children' }
) => {
  let i
  let l
  const key = setting.id
  const parentKey = setting.pid
  if (!key || key === '' || !sNodes) return []
  if (typeOf(sNodes) === 'Array') {
    const r = []
    const tmpMap = {}
    for (i = 0; i < sNodes.length; i++) {
      tmpMap[sNodes[i][key]] = sNodes[i]
    }
    for (i = 0, l = sNodes.length; i < l; i++) {
      const p = tmpMap[sNodes[i][parentKey]]
      if (p && sNodes[i][key] !== sNodes[i][parentKey]) {
        let children = nodeChildren(setting, p, undefined)
        if (!children) {
          children = nodeChildren(setting, p, [])
        }
        children.push(sNodes[i])
      } else {
        r.push(sNodes[i])
      }
    }
    return r
  }
  return [sNodes]
}



// WEBPACK FOOTER //
// ./src/utils/utils.js